
import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Helper function to determine if an element is a heading or subtitle
export function isHeadingOrSubtitle(element: HTMLElement): boolean {
  const headingTags = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];
  return headingTags.includes(element.tagName) || 
         element.classList.contains('font-bold') || 
         element.classList.contains('font-semibold');
}
